import {Component} from 'react';
import PropTypes from 'prop-types';
import {map, range} from 'lodash';
import {Container} from '@mui/material';
import {Document, Page} from 'react-pdf/dist/esm/entry.webpack';

export function PdfContainer({children, onDocumentLoad, loading, url}) {
    return (
        <Document file={url} onLoadSuccess={onDocumentLoad} loading={loading}>
            {children}
        </Document>
    );
}

PdfContainer.propTypes = {
    children: PropTypes.node,
    onDocumentLoad: PropTypes.func,
    onDocumentError: PropTypes.func,
    loading: PropTypes.node,
    url: PropTypes.string,
};

export function PdfPage({pageNumber, width}) {
    const loading = <p>Loading PDF Page {pageNumber}</p>;
    return (
        <Page
            pageNumber={pageNumber}
            width={width}
            scale={1}
            loading={`${loading}`}
        />
    );
}

PdfPage.propTypes = {
    pageNumber: PropTypes.number,
    width: PropTypes.number,
};

export default class PdfReport extends Component {
    static propTypes = {
        loading: PropTypes.node.isRequired,
        maxPages: PropTypes.number,
        url: PropTypes.string.isRequired,
        width: PropTypes.number,
        onPdfError: PropTypes.func,
    };

    static defaultProps = {
        width: 1152,
    };

    state = {
        numPages: null,
    };

    onDocumentLoad = ({numPages}) => {
        this.setState({numPages});
    };

    onDocumentError = (error) => this.props.onPdfError && this.props.onPdfError(error);

    renderPages = (numPages) => {
        const {maxPages = numPages, width} = this.props;
        return map(range(0, maxPages), (i) => {
            return (
                <Container key={i + 1} style={{
                    borderBottom: '1px inset #ddd',
                    marginBottom: '10px',
                    padding: 0,
                }}>
                    <PdfPage pageNumber={i + 1} width={width}/>
                </Container>
            );
        });
    };

    render() {
        const {numPages} = this.state;
        const {loading, url} = this.props;
        return (
            <div className="pdf-report">
                <PdfContainer
                    url={url}
                    loading={loading}
                    onDocumentLoad={this.onDocumentLoad}
                    onDocumentError={this.onDocumentError}
                >
                    {this.renderPages(numPages)}
                </PdfContainer>
            </div>
        );
    }
}
